
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/products/[sku]",
      function () {
        return require("private-next-pages/default/desktop/products/[sku]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/products/[sku]"])
      });
    }
  